module.exports = __webpack_public_path__ + "img/form.00cc6618.svg";